import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./de.json";
import en from "./en.json";
import es from "./es.json";

let LanguageDetector;

if (typeof window !== "undefined") {
  const LDetector = require("i18next-browser-languagedetector").default;
  LanguageDetector = new LDetector();
}

const resources = {
  de: { translation: de },
  en: { translation: en },
  es: { translation: es },
};

if (!i18n.isInitialized) {
  if (LanguageDetector) {
    i18n.use(LanguageDetector); // <<< MUSS vor init stehen!
  }

  i18n
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: "de",
      detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
        lookupLocalStorage: "lang",
      },
      interpolation: { escapeValue: false },
    });
}

export default i18n;
